










































import { Component, Mixins, Emit } from "vue-property-decorator";
import UtilMixin from "@/mixins/utilMixin";

@Component({})
export default class JobsearchRecruiterSearchBox extends Mixins(UtilMixin) {
  /** 検索条件 */
  private recruiter_name = "";
  private recruiter_system_id = "";
  private portal_office_name = "";
  private portal_office_code = "";
  private hst_no = "";
  private kst_no = "";

  /** 検索クリック時 */
  @Emit()
  search() {
    return {
      recruiter_name: this.recruiter_name,
      recruiter_system_id: this.recruiter_system_id,
      portal_office_name: this.portal_office_name,
      portal_office_code: this.portal_office_code,
      hst_no: this.hst_no,
      kst_no: this.kst_no,
    };
  }
}
